import {
  DataEntryOption,
  DetailRequirement,
  EngagementTaskTrait,
  MultipleTaskTraitDetail,
  SingularTaskTraitDetail,
} from '@cibo/core'
import { FriendlyError, Markdown } from '@cibo/ui'
import { Checkbox, FormControlLabel, FormGroup, styled } from '@mui/material'
import { UseQueryResult } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { TaskDataModel } from '../../models/TaskDataModel'

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  marginLeft: 0,
}))

type DataEntryCheckboxListProps = {
  options: DataEntryOption[]
  detailRequirement?: DetailRequirement
  traitConfig: EngagementTaskTrait
  taskData: UseQueryResult<TaskDataModel, Error>
  traitDetailValue: any
  handleChangeDetail: (detail: MultipleTaskTraitDetail | SingularTaskTraitDetail) => void
  immutable?: boolean
}

export const DataEntryCheckboxList = ({
  options,
  detailRequirement,
  traitConfig,
  taskData,
  traitDetailValue,
  handleChangeDetail,
  immutable,
}: DataEntryCheckboxListProps) => {
  const { userDetails, wfDetails } = taskData.data || {}

  const [checkboxValues, setCheckboxValues] = useState<string[]>([])

  useEffect(() => {
    if (!checkboxValues.length) {
      if (traitDetailValue) {
        setCheckboxValues(traitDetailValue as string[])
      }
    }
  }, [userDetails, wfDetails, traitConfig.traitId, traitConfig.dataType, checkboxValues.length])

  if (!taskData) {
    return <FriendlyError message="Task data is not available." />
  }

  return (
    <FormGroup sx={{ pt: 1 }}>
      {options?.map((option: DataEntryOption) => (
        <StyledFormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={!!checkboxValues?.includes(option.value)}
              disabled={immutable}
              onChange={() => {
                setCheckboxValues(prev => {
                  const previousValue = typeof prev === 'string' ? [prev] : prev
                  const isRemoving = prev.includes(option.value)
                  const values = option.exclusive
                    ? [option.value]
                    : isRemoving
                    ? previousValue.filter(valueItem => valueItem !== option.value)
                    : [...previousValue, option.value].filter(
                        valueItem => !options.find(option => option.value === valueItem)?.exclusive
                      )
                  const updateValue = {
                    traitId: traitConfig.traitId,
                    value: values,
                    year: detailRequirement?.year,
                  }

                  handleChangeDetail(updateValue)

                  return values
                })
              }}
              value={option.value}
            />
          }
          label={<Markdown>{option.label}</Markdown>}
        />
      ))}
    </FormGroup>
  )
}
